<template>
	<div class="login-view">
		<header class="site-header">
			<div class="site-header__inner">
				<div class="site-header__logo">
					<span class="site-header__logo-mark">快</span>
					<div class="site-header__logo-text">
						<span class="site-header__brand">快码通</span>
						<span class="site-header__brand-en">KUAIMATONG</span>
					</div>
				</div>
				<nav class="site-header__nav" aria-label="主导航">
					<a href="javascript:void(0)" class="site-header__nav-item" :class="{ 'is-active': activeNav === 'home' }" @click.prevent="setNav('home')">首页</a>
					
					<a href="javascript:void(0)" class="site-header__nav-item" :class="{ 'is-active': activeNav === 'solutions' }" @click.prevent="setNav('solutions')">解决方案</a>
					<a href="javascript:void(0)" class="site-header__nav-item" :class="{ 'is-active': activeNav === 'cases' }" @click.prevent="setNav('cases')">客户案例</a>
				</nav>
				<div class="site-header__tools">
					<div class="site-header__search-row" ref="searchRowWrap" @click.stop>
						<div class="site-header__search-slide" :class="{ 'is-open': searchExpanded }">
							<div class="site-header__search-inner">
								<el-input
									ref="headerSearchInput"
									v-model="searchKeyword"
									size="small"
									placeholder="输入关键词…"
									clearable
									maxlength="100"
									class="site-header__search-input"
									@keyup.enter.native="onSearchConfirm"
								/>
								<el-button type="primary" size="mini" round class="site-header__search-go" @click="onSearchConfirm">确定</el-button>
							</div>
						</div>
						<button
							type="button"
							class="site-header__icon-btn"
							:class="{ 'is-search-active': searchExpanded }"
							title="搜索"
							:aria-expanded="searchExpanded"
							@click="toggleSearchPanel"
						>
							<i class="el-icon-search"></i>
						</button>
					</div>
					<button type="button" class="site-header__icon-btn" title="更多" @click="onHeaderTool">
						<i class="el-icon-menu"></i>
					</button>
				</div>
			</div>
		</header>

		<div class="page-main">
			<transition name="main-swap" mode="out-in" @after-enter="onAfterMainEnter" @before-leave="onBeforeMainLeave">
				<div v-if="activeNav === 'home'" key="home" class="page-stack">
					<section class="hero">
						<div class="hero__media" aria-hidden="true"></div>
						<div class="hero__inner">
							<h1 class="hero__title">快码通S2B2C与多场景协作平台</h1>
							<p class="hero__line">S2B2B / 项目协作 / 客户服务等多模式支持，打造统一沟通入口，</p>
							<p class="hero__line">打通组织架构与业务应用，整合消息、文件与流程，</p>
							<p class="hero__line">回归高效协同本质，为企业构建安全、稳定、可持续演进的数字化底座。</p>
							<button type="button" class="hero__cta" @click="onLearnMore">了解快码通</button>
						</div>
					</section>

					<nav class="sub-nav" aria-label="页面锚点">
						<div class="sub-nav__inner">
							<a v-for="(t, i) in subNavItems" :key="i" href="javascript:void(0)" class="sub-nav__link" @click.prevent="scrollToIntro">{{ t }}</a>
						</div>
					</nav>

					<section ref="sectionIntro" class="intro" id="section-intro">
						<h2 class="intro__title">快码通平台介绍</h2>
						<p class="intro__desc">
							快码通通过统一沟通平台，连接员工、团队与业务系统，结合安全与权限能力，帮助企业完成对内协作与对外服务的一体化升级，为组织打造可信赖的数字化沟通基础设施。
						</p>
					</section>
				</div>

				<div v-else-if="activeNav === 'solutions'" key="solutions" class="page-stack page-stack--solutions">
					<section class="sol-hero">
						<div class="sol-hero__media" aria-hidden="true"></div>
						<div class="sol-hero__inner">
							<h1 class="sol-hero__title">快码通电商解决方案</h1>
							<p class="sol-hero__sub">为企业提供多样化个性解决方案，满足多场景下的业务需求</p>
							<button type="button" class="sol-hero__cta" @click="onQuickSolution">快速获取方案</button>
						</div>
					</section>

					<section class="sol-features">
						<h2 class="sol-features__heading">电商特色解决方案</h2>
						<div class="sol-features__grid">
							<article
								v-for="(card, idx) in solutionCards"
								:key="card.id"
								class="sol-card"
								:style="{ '--delay': (0.28 + idx * 0.06) + 's' }"
							>
								<div class="sol-card__bg" :style="{ backgroundImage: card.bg }"></div>
								<div class="sol-card__overlay" aria-hidden="true"></div>
								<div class="sol-card__body">
									<i :class="card.icon" class="sol-card__icon"></i>
									<h3 class="sol-card__title">{{ card.title }}</h3>
									<span class="sol-card__line" aria-hidden="true"></span>
								</div>
							</article>
						</div>
					</section>
				</div>

				<div v-else-if="activeNav === 'cases'" key="cases" class="page-stack page-stack--cases">
					<section class="cases-hero">
						<div class="cases-hero__media" aria-hidden="true"></div>
						<div class="cases-hero__inner">
							<h1 class="cases-hero__title">客户案例</h1>
							<div class="cases-hero__accent" aria-hidden="true"></div>
							<p class="cases-hero__en">cases</p>
						</div>
					</section>

					<section class="cases-body">
						<div class="cases-body__accent" aria-hidden="true"></div>
						<h2 class="cases-body__title">部分案例</h2>
						<p class="cases-body__lead">
							多年的发展积累沉淀，已服务 10 万+ 客户，快码通为您提供稳定可靠的协作能力与高质量服务。
						</p>

						<div class="cases-carousel">
							<button type="button" class="cases-carousel__arrow cases-carousel__arrow--prev" aria-label="上一案例" @click="prevCase">
								<i class="el-icon-arrow-left"></i>
							</button>
							<div class="cases-carousel__frame">
								<div
									class="cases-carousel__track"
									:style="{ transform: `translate3d(-${caseIndex * 100}%, 0, 0)` }"
								>
									<div v-for="item in caseSlides" :key="item.id" class="cases-carousel__slide">
										<div class="case-card">
											<div class="case-card__visual" :style="{ backgroundImage: `url(${item.image})` }"></div>
											<div class="case-card__panel">
												<div class="case-card__brand">
													<span class="case-card__logo">{{ item.logoMark }}</span>
													<div class="case-card__brand-text">
														<h3 class="case-card__name">{{ item.name }}</h3>
														<p class="case-card__tagline">{{ item.tagline }}</p>
													</div>
												</div>
												<p class="case-card__desc">{{ item.desc }}</p>
												<div class="case-card__modes">
													<span class="case-card__modes-label">电商模式：</span>
													<ul class="case-card__modes-list">
														<li v-for="ch in item.channels" :key="ch.key" class="case-card__mode">
															<i :class="ch.icon" :style="{ color: ch.color }"></i>
															<span>{{ ch.label }}</span>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<button type="button" class="cases-carousel__arrow cases-carousel__arrow--next" aria-label="下一案例" @click="nextCase">
								<i class="el-icon-arrow-right"></i>
							</button>
						</div>
						<div class="cases-carousel__dots" role="tablist" aria-label="案例切换">
							<button
								v-for="(item, idx) in caseSlides"
								:key="'dot-' + item.id"
								type="button"
								class="cases-carousel__dot"
								:class="{ 'is-active': idx === caseIndex }"
								:aria-label="'案例 ' + (idx + 1)"
								:aria-selected="idx === caseIndex"
								role="tab"
								@click="caseIndex = idx"
							></button>
						</div>
					</section>
				</div>
			</transition>
		</div>

		<aside class="float-bar" aria-label="快捷入口">
			<button type="button" class="float-bar__btn float-bar__btn--phone" title="咨询热线" @click="onFloatContact('phone')">
				<i class="el-icon-phone-outline float-bar__btn-icon"></i>
				<span class="float-bar__btn-label">咨询热线</span>
			</button>
			<button type="button" class="float-bar__btn" title="在线咨询" @click="onFloatContact('chat')">
				<i class="el-icon-service float-bar__btn-icon"></i>
				<span class="float-bar__btn-label">在线咨询</span>
			</button>
			<button type="button" class="float-bar__btn" title="微信客服" @click="onFloatContact('wechat')">
				<i class="el-icon-chat-dot-round float-bar__btn-icon"></i>
				<span class="float-bar__btn-label">微信客服</span>
			</button>
			<button type="button" class="float-bar__btn" title="回到顶部" @click="scrollToTop">
				<i class="el-icon-top float-bar__btn-icon"></i>
				<span class="float-bar__btn-label">回到顶部</span>
			</button>
		</aside>

		<icp></icp>
	</div>
</template>

<script>
import Icp from '../components/common/Icp.vue'

export default {
	name: "login",
	components: {
		Icp
	},
	data() {
		return {
			activeNav: "home",
			searchExpanded: false,
			searchKeyword: "",
			subNavItems: [
				"系统概述",
				"适用群体",
				"核心价值",
				"运营模式",
				"系统功能",
				"查看演示",
				"案例介绍",
				"相关文档"
			],
			solutionCards: [
				{
					id: 1,
					title: "新零售解决方案",
					icon: "el-icon-shopping-cart-2",
					bg: 'url("https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1200&q=80")'
				},
				{
					id: 2,
					title: "无人零售解决方案",
					icon: "el-icon-bank-card",
					bg: 'url("https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=1200&q=80")'
				},
				{
					id: 3,
					title: "大数据解决方案",
					icon: "el-icon-data-line",
					bg: 'url("https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80")'
				},
				{
					id: 4,
					title: "供应链解决方案",
					icon: "el-icon-connection",
					bg: 'url("https://images.unsplash.com/photo-1494412574643-ff11b0a5c51c?auto=format&fit=crop&w=1200&q=80")'
				},
				{
					id: 5,
					title: "国际电商解决方案",
					icon: "el-icon-position",
					bg: 'url("https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80")'
				},
				{
					id: 6,
					title: "跨境电商解决方案",
					icon: "el-icon-place",
					bg: 'url("https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=80")'
				}
			],
			caseIndex: 0,
			caseSlides: [
				{
					id: "c1",
					logoMark: "统",
					name: "某某企业（示例）",
					tagline: "台湾规模最大的食品业者之一",
					desc: "快码通为其搭建多端协同与客服体系，打通总部与渠道沟通链路，支撑高并发消息与文件协作，保障业务连续性与数据安全，助力数字化运营效率持续提升。",
					image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=82",
					channels: [
						{ key: "pc", label: "pc端", icon: "el-icon-monitor", color: "#2b7cff" },
						{ key: "wap", label: "Wap端", icon: "el-icon-mobile-phone", color: "#52c41a" },
						{ key: "wx", label: "微信端", icon: "el-icon-chat-dot-round", color: "#07c160" },
						{ key: "app", label: "APP端", icon: "el-icon-mobile", color: "#fa8c16" }
					]
				},
				{
					id: "c2",
					logoMark: "智",
					name: "智联科技集团（示例）",
					tagline: "专注智能制造与供应链数字化",
					desc: "通过快码通企业通讯录、项目群与音视频能力，实现研发、生产、交付多方异地协作；与现有 OA 对接，统一消息触达，缩短问题响应周期，提升跨部门协同体验。",
					image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1400&q=82",
					channels: [
						{ key: "pc", label: "pc端", icon: "el-icon-monitor", color: "#2b7cff" },
						{ key: "wap", label: "Wap端", icon: "el-icon-mobile-phone", color: "#52c41a" },
						{ key: "wx", label: "微信端", icon: "el-icon-chat-dot-round", color: "#07c160" },
						{ key: "app", label: "APP端", icon: "el-icon-mobile", color: "#fa8c16" }
					]
				},
				{
					id: "c3",
					logoMark: "云",
					name: "云尚零售（示例）",
					tagline: "全国连锁新零售品牌运营商",
					desc: "门店与总部使用快码通进行日清复盘与活动同步，结合机器人通知与已读回执，确保政策一键下达；大促期间消息通道稳定，支撑客服与运营高峰协同。",
					image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1400&q=82",
					channels: [
						{ key: "pc", label: "pc端", icon: "el-icon-monitor", color: "#2b7cff" },
						{ key: "wap", label: "Wap端", icon: "el-icon-mobile-phone", color: "#52c41a" },
						{ key: "wx", label: "微信端", icon: "el-icon-chat-dot-round", color: "#07c160" },
						{ key: "app", label: "APP端", icon: "el-icon-mobile", color: "#fa8c16" }
					]
				}
			]
		};
	},
	mounted() {
		document.addEventListener("click", this.closeSearchOnOutsideClick);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.closeSearchOnOutsideClick);
	},
	methods: {
		setNav(nav) {
			this.activeNav = nav;
			if (nav === "cases") {
				this.caseIndex = 0;
			}
			this.$nextTick(() => {
				if (this.$el && this.$el.scrollTo) {
					this.$el.scrollTo({ top: 0, behavior: "smooth" });
				}
			});
		},
		onNavOther(type) {
			const map = {
				product: "产品功能",
				help: "帮助支持"
			};
			this.$message.info(`${map[type] || "该"}模块开发中`);
		},
		onAfterMainEnter(el) {
			this.$nextTick(() => {
				if (el && el.classList && el.classList.contains("page-stack--solutions")) {
					el.classList.add("sol-anim--show");
				}
			});
		},
		onBeforeMainLeave(el) {
			if (el && el.classList) {
				el.classList.remove("sol-anim--show");
			}
		},
		prevCase() {
			const n = this.caseSlides.length;
			if (!n) return;
			this.caseIndex = (this.caseIndex - 1 + n) % n;
		},
		nextCase() {
			const n = this.caseSlides.length;
			if (!n) return;
			this.caseIndex = (this.caseIndex + 1) % n;
		},
		onQuickSolution() {
			this.$message.success("已记录您的需求，我们将尽快与您联系");
		},
		onHeaderTool() {
			this.$message.info("功能开发中");
		},
		closeSearchOnOutsideClick(e) {
			const wrap = this.$refs.searchRowWrap;
			if (this.searchExpanded && wrap && !wrap.contains(e.target)) {
				this.searchExpanded = false;
			}
		},
		toggleSearchPanel() {
			this.searchExpanded = !this.searchExpanded;
			if (this.searchExpanded) {
				this.$nextTick(() => {
					const comp = this.$refs.headerSearchInput;
					if (comp && comp.$refs && comp.$refs.input) {
						comp.$refs.input.focus();
					}
				});
			}
		},
		onSearchConfirm() {
			this.searchExpanded = false;
			this.searchKeyword = "";
			this.$message.info("暂无内容");
		},
		onLearnMore() {
			this.scrollToIntro();
		},
		scrollToIntro() {
			const el = this.$refs.sectionIntro;
			if (el && el.scrollIntoView) {
				el.scrollIntoView({ behavior: "smooth", block: "start" });
			}
		},
		scrollToTop() {
			this.$el.scrollTo({ top: 0, behavior: "smooth" });
		},
		onFloatContact(type) {
			const map = { phone: "咨询热线", chat: "在线咨询", wechat: "微信客服" };
			this.$message.info(`${map[type] || "客服"}功能开发中`);
		}
	}
}
</script>

<style scoped lang="scss">
/* 设计参考：白顶栏 + 橙主色 + 港口 Hero 深蓝遮罩 + 次级导航 + 介绍区 + 右侧悬浮条 */
$orange: #ff6600;
$orange-hover: #e85d00;
$text-title: #333333;
$text-body: #666666;
$text-muted: #888888;
$header-border: #eeeeee;
$hero-overlay-0: rgba(18, 42, 72, 0.88);
$hero-overlay-1: rgba(18, 42, 72, 0.62);

/* 可替换为 public/login-hero.png 以使用本地设计图 */
$hero-image: url("https://images.unsplash.com/photo-1578575437130-527eed3a25f7?auto=format&fit=crop&w=2000&q=82");

.login-view {
	width: 100%;
	height: 100%;
	min-height: 100%;
	box-sizing: border-box;
	position: relative;
	background: #fff;
	overflow-x: hidden;
	overflow-y: auto;
	font-family: Microsoft YaHei, PingFang SC, Hiragino Sans GB, sans-serif;
}

.site-header {
	position: sticky;
	top: 0;
	z-index: 100;
	background: #fff;
	border-bottom: 1px solid $header-border;
	box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03);

	&__inner {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 24px;
		height: 64px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 24px;
		box-sizing: border-box;
	}

	&__logo {
		display: flex;
		align-items: center;
		gap: 12px;
		flex-shrink: 0;
	}

	&__logo-mark {
		width: 44px;
		height: 44px;
		border-radius: 50%;
		background: $orange;
		color: #fff;
		font-size: 22px;
		font-weight: 700;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		box-shadow: 0 2px 8px rgba(255, 102, 0, 0.35);
	}

	&__logo-text {
		display: flex;
		flex-direction: column;
		line-height: 1.2;
	}

	&__brand {
		font-size: 24px;
		font-weight: 700;
		color: $text-title;
		letter-spacing: 0.02em;
	}

	&__brand-en {
		font-size: 14px;
		color: $text-muted;
		letter-spacing: 0.14em;
		margin-top: 2px;
	}

	&__nav {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		flex-wrap: wrap;
		gap: 4px 8px;
		min-width: 0;
	}

	&__nav-item {
		padding: 8px 12px;
		font-size: 19px;
		color: $text-body;
		text-decoration: none;
		white-space: nowrap;
		cursor: pointer;
		transition: color 0.15s ease;
		display: inline-flex;
		align-items: center;
		gap: 4px;

		&:hover {
			color: $orange;
		}

		&.is-active {
			color: $orange;
			font-weight: 600;
		}
	}

	&__caret {
		font-size: 16px;
		margin-left: 2px;
	}

	&__tools {
		display: flex;
		align-items: center;
		gap: 4px;
		flex-shrink: 0;
	}

	&__icon-btn {
		width: 44px;
		height: 44px;
		padding: 0;
		border: none;
		background: transparent;
		color: #555;
		font-size: 24px;
		cursor: pointer;
		border-radius: 4px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		transition: color 0.15s ease, background 0.15s ease, box-shadow 0.25s ease;

		&:hover {
			color: $orange;
			background: rgba(255, 102, 0, 0.06);
		}

		&.is-search-active {
			color: $orange;
			background: rgba(255, 102, 0, 0.1);
			box-shadow: 0 0 0 2px rgba(255, 102, 0, 0.28);
			border-radius: 50%;
		}
	}

	&__search-row {
		display: inline-flex;
		flex-direction: row;
		align-items: center;
		gap: 6px;
	}

	&__search-slide {
		max-width: 0;
		opacity: 0;
		transform: translateX(18px);
		overflow: hidden;
		pointer-events: none;
		transition: max-width 0.52s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.34s ease, transform 0.52s cubic-bezier(0.22, 1, 0.36, 1);

		@media (prefers-reduced-motion: reduce) {
			transition-duration: 0.01ms;
		}

		&.is-open {
			max-width: 380px;
			opacity: 1;
			transform: translateX(0);
			pointer-events: auto;
		}
	}

	&__search-inner {
		display: flex;
		align-items: center;
		gap: 8px;
		min-width: 260px;
		padding: 5px 6px 5px 12px;
		border-radius: 26px;
		background: linear-gradient(145deg, rgba(255, 255, 255, 0.98) 0%, #f0f4fa 55%, #e8eef6 100%);
		border: 1px solid rgba(255, 102, 0, 0.38);
		box-shadow:
			0 0 0 1px rgba(255, 255, 255, 0.65) inset,
			0 4px 18px rgba(255, 102, 0, 0.14),
			0 10px 36px rgba(0, 31, 63, 0.1);
		backdrop-filter: blur(12px);
	}

	&__search-input {
		flex: 1;
		min-width: 0;
	}

	&__search-go {
		flex-shrink: 0;
		padding-left: 14px;
		padding-right: 14px;
		font-weight: 600;
	}

	::v-deep .site-header__search-input .el-input__inner {
		height: 32px;
		line-height: 32px;
		border-radius: 18px;
		border-color: rgba(255, 102, 0, 0.22);
		transition: border-color 0.22s ease, box-shadow 0.22s ease;

		&:focus {
			border-color: rgba(255, 102, 0, 0.55);
			box-shadow: 0 0 0 2px rgba(255, 102, 0, 0.12);
		}
	}
}

.page-main {
	width: 100%;
	background: #fff;
}

.hero {
	position: relative;
	color: #fff;
	min-height: clamp(320px, 48vh, 520px);
	display: flex;
	align-items: flex-end;

	&__media {
		position: absolute;
		inset: 0;
		background-image: linear-gradient(105deg, $hero-overlay-0 0%, $hero-overlay-1 50%, rgba(18, 42, 72, 0.45) 100%), $hero-image;
		background-size: cover;
		background-position: center;
		/* 若存在 public/login-hero.png，可改为：linear-gradient(...), url(/login-hero.png) */
	}

	&__inner {
		position: relative;
		z-index: 1;
		max-width: 1200px;
		width: 100%;
		margin: 0 auto;
		padding: 48px 24px 52px;
		box-sizing: border-box;
	}

	&__title {
		margin: 0 0 24px;
		max-width: 640px;
		font-size: clamp(26px, 2.6vw, 36px);
		font-weight: 700;
		line-height: 1.45;
		letter-spacing: 0.02em;
		text-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
	}

	&__line {
		margin: 0 0 10px;
		max-width: 600px;
		font-size: 15px;
		line-height: 1.85;
		color: rgba(255, 255, 255, 0.95);
	}

	&__line:last-of-type {
		margin-bottom: 28px;
	}

	&__cta {
		display: inline-block;
		padding: 11px 28px;
		font-size: 15px;
		color: #fff;
		background: transparent;
		border: 1px solid rgba(255, 255, 255, 0.95);
		border-radius: 2px;
		cursor: pointer;
		transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

		&:hover {
			background: rgba(255, 255, 255, 0.12);
			border-color: #fff;
		}
	}
}

.sub-nav {
	background: #fff;
	border-bottom: 1px solid $header-border;
	box-shadow: 0 1px 0 rgba(0, 0, 0, 0.02);

	&__inner {
		max-width: 1200px;
		margin: 0 auto;
		padding: 14px 24px;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		gap: 8px 28px;
		box-sizing: border-box;
	}

	&__link {
		font-size: 18px;
		color: $text-body;
		text-decoration: none;
		white-space: nowrap;
		cursor: pointer;
		transition: color 0.15s ease;

		&:hover {
			color: $orange;
		}
	}
}

.intro {
	max-width: 1200px;
	margin: 0 auto;
	padding: 40px 24px 80px;
	text-align: center;
	box-sizing: border-box;

	&__title {
		margin: 0 0 20px;
		font-size: 30px;
		font-weight: 700;
		color: $text-title;
		letter-spacing: 0.02em;
	}

	&__desc {
		margin: 0 auto;
		max-width: 900px;
		font-size: 15px;
		line-height: 2;
		color: $text-body;
	}
}

/* 主内容切换：淡入 + 轻微上移 */
.main-swap-enter-active,
.main-swap-leave-active {
	transition: opacity 0.38s cubic-bezier(0.4, 0, 0.2, 1), transform 0.38s cubic-bezier(0.4, 0, 0.2, 1);
}

.main-swap-enter,
.main-swap-leave-to {
	opacity: 0;
	transform: translateY(18px);
}

.page-stack {
	width: 100%;
}

/* —— 解决方案：图1 Hero（居中 / 深蓝遮罩 / 虚化办公底图）—— */
.sol-hero {
	position: relative;
	min-height: clamp(420px, 58vh, 620px);
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	overflow: hidden;

	&__media {
		position: absolute;
		inset: 0;
		overflow: hidden;

		&::before {
			content: "";
			position: absolute;
			inset: -28px;
			background-image: url("https://images.unsplash.com/photo-1498049794568-2a53a2b0ff21?auto=format&fit=crop&w=2000&q=82");
			background-size: cover;
			background-position: center;
			filter: blur(6px);
			transform: scale(1.06);
		}

		&::after {
			content: "";
			position: absolute;
			inset: 0;
			background: linear-gradient(180deg, rgba(0, 31, 63, 0.86) 0%, rgba(0, 31, 63, 0.74) 100%);
		}
	}

	&__inner {
		position: relative;
		z-index: 1;
		max-width: 920px;
		margin: 0 auto;
		padding: 56px 24px;
		text-align: center;
		box-sizing: border-box;
	}

	&__title {
		margin: 0 0 20px;
		font-size: clamp(34px, 3.8vw, 44px);
		font-weight: 700;
		line-height: 1.35;
		letter-spacing: 0.04em;
		text-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
		opacity: 0;
		transform: translateY(28px);
	}

	&__sub {
		margin: 0 auto 32px;
		max-width: 720px;
		font-size: 19px;
		line-height: 1.85;
		font-weight: 400;
		color: rgba(255, 255, 255, 0.94);
		opacity: 0;
		transform: translateY(28px);
	}

	&__cta {
		display: inline-block;
		padding: 12px 36px;
		font-size: 16px;
		color: #fff;
		background: transparent;
		border: 1px solid rgba(255, 255, 255, 0.95);
		border-radius: 2px;
		cursor: pointer;
		transition: background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
		opacity: 0;
		transform: translateY(28px);

		&:hover {
			background: rgba(255, 255, 255, 0.1);
			box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
		}
	}
}

/* 解决方案页：进入后依次浮现 */
@keyframes sol-reveal {
	from {
		opacity: 0;
		transform: translateY(26px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes sol-card-in {
	from {
		opacity: 0;
		transform: translateY(22px) scale(0.98);
	}
	to {
		opacity: 1;
		transform: translateY(0) scale(1);
	}
}

.page-stack--solutions.sol-anim--show .sol-hero__title {
	animation: sol-reveal 0.65s cubic-bezier(0.22, 1, 0.36, 1) 0.06s forwards;
}

.page-stack--solutions.sol-anim--show .sol-hero__sub {
	animation: sol-reveal 0.65s cubic-bezier(0.22, 1, 0.36, 1) 0.16s forwards;
}

.page-stack--solutions.sol-anim--show .sol-hero__cta {
	animation: sol-reveal 0.65s cubic-bezier(0.22, 1, 0.36, 1) 0.26s forwards;
}

.page-stack--solutions.sol-anim--show .sol-features__heading {
	animation: sol-reveal 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.32s forwards;
}

.page-stack--solutions.sol-anim--show .sol-card {
	animation: sol-card-in 0.58s cubic-bezier(0.22, 1, 0.36, 1) both;
	animation-delay: var(--delay, 0.35s);
}

/* —— 解决方案：图2 特色方案网格 —— */
.sol-features {
	padding: 48px 24px 72px;
	background: #fff;
	box-sizing: border-box;

	&__heading {
		margin: 0 0 36px;
		text-align: center;
		font-size: 34px;
		font-weight: 700;
		color: #001f3f;
		letter-spacing: 0.06em;
		opacity: 0;
		transform: translateY(20px);
	}

	&__grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 20px;
		max-width: 1200px;
		margin: 0 auto;
		box-sizing: border-box;
	}
}

.sol-card {
	position: relative;
	border-radius: 2px;
	overflow: hidden;
	aspect-ratio: 16 / 9;
	min-height: 180px;
	opacity: 0;
	transform: translateY(22px);
	cursor: default;
	box-shadow: 0 8px 28px rgba(0, 31, 63, 0.12);

	&__bg {
		position: absolute;
		inset: 0;
		background-size: cover;
		background-position: center;
		transition: transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);
	}

	&__overlay {
		position: absolute;
		inset: 0;
		background: linear-gradient(180deg, rgba(0, 20, 45, 0.45) 0%, rgba(0, 20, 45, 0.78) 100%);
		transition: opacity 0.4s ease, background 0.4s ease;
	}

	&__body {
		position: relative;
		z-index: 1;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 24px 16px;
		box-sizing: border-box;
		text-align: center;
	}

	&__icon {
		font-size: 44px;
		color: #fff;
		margin-bottom: 14px;
		line-height: 1;
		filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.25));
	}

	&__title {
		margin: 0;
		font-size: 20px;
		font-weight: 600;
		color: #fff;
		line-height: 1.45;
		letter-spacing: 0.04em;
		text-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
	}

	&__line {
		display: block;
		width: 36px;
		height: 2px;
		margin-top: 16px;
		background: rgba(255, 255, 255, 0.85);
		border-radius: 1px;
	}

	&:hover .sol-card__bg {
		transform: scale(1.06);
	}

	&:hover .sol-card__overlay {
		opacity: 0.92;
		background: linear-gradient(180deg, rgba(0, 31, 63, 0.5) 0%, rgba(0, 31, 63, 0.82) 100%);
	}
}

@media (max-width: 960px) {
	.sol-features__grid {
		grid-template-columns: repeat(2, 1fr);
	}
}

@media (max-width: 600px) {
	.sol-features__grid {
		grid-template-columns: 1fr;
	}

	.sol-hero__sub {
		font-size: 17px;
	}
}

/* —— 客户案例页 —— */
$case-blue: #001f3f;
$case-arrow: #2b7cff;

.cases-hero {
	position: relative;
	min-height: clamp(360px, 46vh, 480px);
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	overflow: hidden;

	&__media {
		position: absolute;
		inset: 0;

		&::before {
			content: "";
			position: absolute;
			inset: 0;
			background-image: url("https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=2000&q=82");
			background-size: cover;
			background-position: center 35%;
		}

		&::after {
			content: "";
			position: absolute;
			inset: 0;
			background: linear-gradient(180deg, rgba(0, 24, 48, 0.72) 0%, rgba(0, 18, 40, 0.82) 100%);
		}
	}

	&__inner {
		position: relative;
		z-index: 1;
		text-align: center;
		padding: 48px 24px;
	}

	&__title {
		margin: 0 0 16px;
		font-size: clamp(34px, 4vw, 46px);
		font-weight: 700;
		letter-spacing: 0.12em;
		text-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
	}

	&__accent {
		width: 48px;
		height: 3px;
		margin: 0 auto 14px;
		background: $orange;
		border-radius: 2px;
	}

	&__en {
		margin: 0;
		font-size: 17px;
		font-weight: 400;
		letter-spacing: 0.28em;
		text-transform: lowercase;
		color: rgba(255, 255, 255, 0.92);
	}
}

.cases-body {
	padding: 48px 20px 72px;
	background: #fff;
	box-sizing: border-box;

	&__accent {
		width: 40px;
		height: 3px;
		margin: 0 auto 14px;
		background: $orange;
		border-radius: 2px;
	}

	&__title {
		margin: 0 0 16px;
		text-align: center;
		font-size: 34px;
		font-weight: 700;
		color: $case-blue;
		letter-spacing: 0.08em;
	}

	&__lead {
		margin: 0 auto 40px;
		max-width: 880px;
		text-align: center;
		font-size: 16px;
		line-height: 1.9;
		color: $text-body;
	}
}

.cases-carousel {
	display: flex;
	align-items: stretch;
	justify-content: center;
	gap: 8px;
	max-width: 1280px;
	margin: 0 auto;
	box-sizing: border-box;
}

.cases-carousel__frame {
	flex: 1;
	min-width: 0;
	overflow: hidden;
	border-radius: 2px;
}

.cases-carousel__track {
	display: flex;
	width: 100%;
	transition: transform 0.58s cubic-bezier(0.22, 1, 0.36, 1);
	will-change: transform;
	backface-visibility: hidden;
}

@media (prefers-reduced-motion: reduce) {
	.cases-carousel__track {
		transition-duration: 0.01ms;
	}
}

.cases-carousel__slide {
	flex: 0 0 100%;
	width: 100%;
	min-width: 100%;
	box-sizing: border-box;
	padding: 0 6px;
}

.cases-carousel__arrow {
	flex-shrink: 0;
	width: 44px;
	align-self: center;
	height: 120px;
	margin-top: 0;
	border: none;
	background: transparent;
	color: $case-arrow;
	font-size: 28px;
	cursor: pointer;
	border-radius: 4px;
	transition: color 0.2s ease, background 0.2s ease, transform 0.2s ease;

	&:hover {
		color: #1a5fd4;
		background: rgba(43, 124, 255, 0.06);
	}

	&:active {
		transform: scale(0.94);
	}
}

.case-card {
	display: grid;
	grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
	min-height: 320px;
	background: #fff;
	border-radius: 2px;
	box-shadow: 0 12px 40px rgba(0, 31, 63, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04);
	overflow: hidden;
	box-sizing: border-box;
}

.case-card__visual {
	min-height: 280px;
	background-size: cover;
	background-position: center;
}

.case-card__panel {
	padding: 32px 28px 28px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	box-sizing: border-box;
}

.case-card__brand {
	display: flex;
	align-items: flex-start;
	gap: 14px;
	margin-bottom: 16px;
}

.case-card__logo {
	flex-shrink: 0;
	width: 48px;
	height: 48px;
	border-radius: 4px;
	background: linear-gradient(135deg, #ff6600 0%, #ff8533 100%);
	color: #fff;
	font-size: 22px;
	font-weight: 700;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 4px 12px rgba(255, 102, 0, 0.35);
}

.case-card__name {
	margin: 0 0 6px;
	font-size: 22px;
	font-weight: 700;
	color: $text-title;
	line-height: 1.3;
}

.case-card__tagline {
	margin: 0;
	font-size: 15px;
	color: $text-title;
	line-height: 1.5;
}

.case-card__desc {
	margin: 0 0 22px;
	font-size: 15px;
	line-height: 1.85;
	color: $text-body;
	flex: 1;
}

.case-card__modes {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 10px 16px;
	padding-top: 4px;
	border-top: 1px solid #f0f0f0;
}

.case-card__modes-label {
	font-size: 14px;
	font-weight: 600;
	color: $text-title;
	white-space: nowrap;
}

.case-card__modes-list {
	display: flex;
	flex-wrap: wrap;
	gap: 14px 20px;
	margin: 0;
	padding: 0;
	list-style: none;
}

.case-card__mode {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	color: $text-body;

	i {
		font-size: 18px;
	}
}

.cases-carousel__dots {
	display: none;
	justify-content: center;
	gap: 10px;
	margin-top: 20px;
}

.cases-carousel__dot {
	width: 8px;
	height: 8px;
	padding: 0;
	border: none;
	border-radius: 50%;
	background: #d9d9d9;
	cursor: pointer;
	transition: transform 0.25s ease, background 0.25s ease;

	&.is-active {
		background: $case-arrow;
		transform: scale(1.25);
	}
}

@media (max-width: 900px) {
	.case-card {
		grid-template-columns: 1fr;
	}

	.case-card__visual {
		min-height: 220px;
	}

	.cases-carousel__arrow {
		width: 36px;
		font-size: 22px;
		height: 80px;
	}
}

@media (max-width: 600px) {
	.cases-carousel {
		flex-direction: column;
		gap: 12px;
	}

	.cases-carousel__arrow {
		display: none;
	}

	.cases-carousel__dots {
		display: flex;
	}

	.cases-carousel__slide {
		padding: 0;
	}

	.case-card__panel {
		padding: 24px 18px;
	}
}

.float-bar {
	position: fixed;
	right: 16px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 90;
	display: flex;
	flex-direction: column;
	width: 72px;
	box-shadow: -2px 0 12px rgba(0, 0, 0, 0.08);
	border-radius: 4px;
	overflow: hidden;
	background: #fff;

	&__btn {
		width: 100%;
		min-height: 72px;
		height: auto;
		padding: 10px 6px 12px;
		border: none;
		border-top: 1px solid #eee;
		background: #fff;
		color: #666;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 6px;
		transition: background 0.15s ease, color 0.15s ease;

		&:first-child {
			border-top: none;
		}

		&:hover {
			color: $orange;
			background: #fffaf5;

			.float-bar__btn-label {
				color: $orange;
			}
		}

		&--phone {
			background: $orange;
			color: #fff;

			.float-bar__btn-label {
				color: rgba(255, 255, 255, 0.95);
			}

			&:hover {
				background: $orange-hover;
				color: #fff;

				.float-bar__btn-label {
					color: #fff;
				}
			}
		}
	}

	&__btn-icon {
		font-size: 22px;
		line-height: 1;
	}

	&__btn-label {
		display: block;
		font-size: 11px;
		font-weight: 500;
		line-height: 1.2;
		letter-spacing: 0.02em;
		color: #666;
		text-align: center;
		max-width: 100%;
		word-break: keep-all;
	}
}

@media (max-width: 1100px) {
	.site-header__inner {
		flex-wrap: nowrap;
	}

	.site-header__nav {
		justify-content: flex-end;
		overflow-x: auto;
		flex: 1 1 auto;
		flex-wrap: nowrap;
		-webkit-overflow-scrolling: touch;
		gap: 2px;
		padding-bottom: 2px;
		mask-image: linear-gradient(to right, transparent, #000 12px, #000 calc(100% - 12px), transparent);
	}

	.site-header__nav-item {
		padding: 8px 10px;
		flex-shrink: 0;
	}
}

@media (max-width: 960px) {
	.hero {
		min-height: 360px;
	}

	.sol-hero {
		min-height: 380px;
	}

	.float-bar {
		right: 12px;
		top: auto;
		bottom: 100px;
		transform: none;
	}
}

@media (max-width: 480px) {
	.site-header__inner {
		padding: 0 16px;
		height: 56px;
	}

	.site-header__brand {
		font-size: 22px;
	}

	.site-header__search-slide.is-open {
		max-width: min(320px, calc(100vw - 100px));
	}

	.site-header__search-inner {
		min-width: 0;
		width: min(300px, calc(100vw - 88px));
	}

	.hero__inner {
		padding: 32px 16px 40px;
	}

	.sub-nav__inner {
		justify-content: flex-start;
		overflow-x: auto;
		flex-wrap: nowrap;
		padding-bottom: 4px;
		-webkit-overflow-scrolling: touch;
	}

	.intro {
		padding: 28px 16px 36px;

		&__title {
			font-size: 26px;
		}
	}
}
</style>
